type TableNameProps = {
    required?: boolean;
    children: React.ReactNode;
    className?: string;
};

const TableName = ({ required, children, className }: TableNameProps) => {
    return (
        <div className={`${className} whitespace-nowrap items-center flex bg-[#F3F3F8] gap-1 w-[100px] min-w-[100px] px-3`}>
            <p className="text-sm text-gray2">{children}</p>
            {required && <p className="text-primary2 -translate-y-0.5">*</p>}
        </div>
    );
};

export default TableName;
